import { render, staticRenderFns } from "./DecisionDiamondRuleGroup.vue?vue&type=template&id=e4dcf37c&scoped=true"
import script from "./DecisionDiamondRuleGroup.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondRuleGroup.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondRuleGroup.vue?vue&type=style&index=0&id=e4dcf37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dcf37c",
  null
  
)

export default component.exports